import { calmTokens as t } from '../shared/tokens';
import { deriveUserDisplay } from '../shared/format';
import { IconLeaf, IconLogout } from '../shared/icons';
import { NAV_ITEMS } from '../shared/nav';
import CalmNavPill from './CalmNavPill';

export default function CalmHeader({
  user,
  currentView,
  onViewChange,
  onLogout,
  mobileSlot,
}) {
  const { initials } = deriveUserDisplay(user?.email);

  return (
    <header
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '20px 40px',
        position: 'relative',
        zIndex: 2,
        gap: 20,
      }}
      className="calm-header"
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 40, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: 9,
              background: `linear-gradient(140deg, ${t.accent}, ${t.accentStrong})`,
              display: 'grid',
              placeItems: 'center',
              color: t.bg,
            }}
            aria-hidden="true"
          >
            <IconLeaf size={16} />
          </div>
          <span
            style={{
              fontFamily: t.fontDisp,
              fontSize: 18,
              fontWeight: 500,
              letterSpacing: -0.3,
              color: t.text,
              whiteSpace: 'nowrap',
            }}
          >
            Ma Comptabilité
          </span>
        </div>

        <nav
          className="calm-nav-desktop"
          style={{ display: 'flex', gap: 4 }}
        >
          {NAV_ITEMS.map((item) => (
            <CalmNavPill
              key={item.id}
              icon={item.icon(15)}
              label={item.label}
              active={currentView === item.id}
              onClick={() => onViewChange && onViewChange(item.id)}
            />
          ))}
        </nav>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <span
          className="calm-email-desktop"
          style={{
            fontSize: 13,
            color: t.textDim,
            fontFamily: t.fontUi,
            maxWidth: 220,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {user?.email}
        </span>
        <div
          style={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            background: `linear-gradient(135deg, ${t.accent}, ${t.accentStrong})`,
            display: 'grid',
            placeItems: 'center',
            color: t.bg,
            fontSize: 12,
            fontWeight: 600,
            letterSpacing: 0.5,
            fontFamily: t.fontUi,
            flexShrink: 0,
          }}
          aria-label={`Avatar ${initials}`}
        >
          {initials}
        </div>
        <button
          type="button"
          onClick={onLogout}
          className="calm-logout-desktop"
          title="Déconnexion"
          aria-label="Déconnexion"
          style={{
            width: 34,
            height: 34,
            borderRadius: 10,
            background: 'transparent',
            border: `1px solid ${t.border}`,
            color: t.textDim,
            cursor: 'pointer',
            display: 'grid',
            placeItems: 'center',
            padding: 0,
            transition: 'all .15s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = t.debit;
            e.currentTarget.style.borderColor = t.debitBorder;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = t.textDim;
            e.currentTarget.style.borderColor = t.border;
          }}
        >
          <IconLogout size={15} />
        </button>
        {mobileSlot}
      </div>

      <style>{`
        @media (max-width: 1024px) {
          .calm-header {
            padding: 16px 20px !important;
          }
          .calm-nav-desktop {
            display: none !important;
          }
          .calm-email-desktop {
            display: none !important;
          }
        }
        /* Paysage mobile : chaque pixel vertical compte. Doit rester APRÈS la
           règle ci-dessus, qui pose le même padding en !important. */
        @media (orientation: landscape) and (max-height: 520px) {
          .calm-header {
            padding: 4px 16px !important;
          }
        }
      `}</style>
    </header>
  );
}
